import axios from 'axios';

export const owk = {
	actions: {
		confirmOwkData({ commit, dispatch }, data) {
			commit('setMyfxSave', true);
			dispatch('newLogoutTime');
			return new Promise((resolve, reject) => {
				let todayDate = new Date();
				if (
					data &&
					(!data.documentValidityDate ||
						new Date(data.documentValidityDate).getTime() <
							new Date(
								todayDate.toISOString().split('T')[0]
							).getTime()) &&
					!data.documentNotExpiring
				) {
					reject('Data ważności dokumentu jest nieprawidłowa.');
					commit('setShowValidateDataDialog', false);
					commit('setMyfxSave', false);
				} else {
					axios
						.post('Client/OwkConfirmData', null)
						.then(() => {
							commit('setShowValidateDataDialog', false);
							commit('setMyfxSave', false);
							resolve('Dane zostały potwierdzone');
						})
						.catch(() => {
							commit('setShowValidateDataDialog', false);
							commit('setMyfxSave', false);
							reject('Wystąpił błąd');
						});
				}
			});
		},
	},
};
